
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/[region]/[locale]/select-store",
      function () {
        return require("private-next-pages/[region]/[locale]/select-store.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/[region]/[locale]/select-store"])
      });
    }
  